import React, { useState } from "react";
import "./sahibindenFilters.css";

function FilterAccordion({ title, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="fp-accordion">
      <button
        type="button"
        className="fp-accordion-head"
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>{title}</span>
        <i className={`fa ${open ? "fa-angle-up" : "fa-angle-down"}`} />
      </button>
      {open && <div className="fp-accordion-body">{children}</div>}
    </div>
  );
}

export default FilterAccordion;
